import { LoggingService } from '../services/logging.service';
import { ILogger, LogLevel } from '@microsoft/signalr';

export class SignalRLogger implements ILogger {
  constructor(private logService: LoggingService) {}

  log(logLevel: LogLevel, message: string) {
    if (logLevel >= LogLevel.Error) {
      this.logService.logMessage(logLevel, message);
    }
  }
}
